export type ConfigKey =
	SharedConfigKey |
	PdfSharedConfigKey |
	FundStatsConfigKey |
	IqConfigKey |
	PaConfigKey |
	PeConfigKey |
	PcConfigKey |
	CmaConfigKey |
	SharedConfigKey |
	IretireAccumConfigKey |
	IretireDecumConfigKey |
	DashboardConfigKey |
	ModelsExperienceConfigKey |
	TaxConfigKey |
	MonitoringConfigKey |
	ACPortfolioLibraryConfigKey;

export enum SharedConfigKey {
	ASSET_CLASS_COLORS = 'ASSET_CLASS_COLORS',
	ASSET_CLASS_ORDER = 'ASSET_CLASS_ORDER',
	ShowFte = 'SHOW_FTE',
	ShowPbaLogo = 'SHOW_PBA_LOGO',
	AteShowTaxSavingsInsights = 'ATE_SHOW_TAX_SAVINGS_INSIGHTS',
	EsgCarbonEquivalencies = 'ESG_CARBON_EQUIVALENCIES',
	EsgRatingsRangeScale = 'ESG_RATINGS_RANGE_SCALE',
	EsgScoreRangeScale = 'ESG_SCORE_RANGE_SCALE',
	ESG_ASSET_TYPES_TO_INCLUDE = 'ESG_ASSET_TYPES_TO_INCLUDE',
	EnableCustomFee = 'ENABLE_CUSTOM_FEE',
	ENABLE_BENCHMARK_CURRENCY_SETTINGS = 'ENABLE_BENCHMARK_CURRENCY_SETTINGS',
	ENABLE_PORTFOLIO_SHARING = 'ENABLE_PORTFOLIO_SHARING',
	ShouldMakePerformanceSleeveApi = 'SHOULD_MAKE_PERFORMANCE_SLEEVE_API',
	SHOULD_MAKE_SIMPLE_PERFORMANCE_API_CALL = 'SHOULD_MAKE_SIMPLE_PERFORMANCE_API_CALL',
	PortfolioEditor = 'PORTFOLIO_EDITOR',
	PORTFOLIO_LIBRARY_DATE_FORMAT = 'PORTFOLIO_LIBRARY_DATE_FORMAT',
	SHOULD_REMOVE_PREVIOUS_PERFORMANCE_ANALYSIS = 'SHOULD_REMOVE_PREVIOUS_PERFORMANCE_ANALYSIS',
	RemoveStaleAnalysisForFailedPortfolios = 'REMOVE_STALE_WWE_ANALYSIS_FOR_FAILED_PORTFOLIOS',
	WDS_APPS = 'WDS_APPS',
	WWE_APPS = 'WWE_APPS',
	SHOW_FUND_PROSPECTUS = 'SHOW_FUND_PROSPECTUS',
	ERROR_LISTINGS_LIMIT_PER_GROUP = 'ERROR_LISTINGS_LIMIT_PER_GROUP',
	SHOW_CLIENT_REPORT_BUTTON = 'SHOW_CLIENT_REPORT_BUTTON',
	TAX_HISTORICAL_COLUMNS = 'TAX_HISTORICAL_COLUMNS',
	TM_TAX_HISTORICAL_COLUMNS = 'TM_TAX_HISTORICAL_COLUMNS',
	AWE_USE_ALADDINID = 'AWE_USE_ALADDINID',
	SEC_RESEARCH_MODELS = 'SEC_RESEARCH_MODELS',
	SIDENAV_ROUTE_PATHS = 'SIDENAV_ROUTE_PATHS',
	HEADER_BUTTON_HELP_CENTER = 'HEADER_BUTTON_HELP_CENTER',
	TAX_DEFAULT_AUM = 'TAX_DEFAULT_AUM',
	ENABLE_HYPO_CHART_PERIOD_CHANGE = 'ENABLE_HYPO_CHART_PERIOD_CHANGE',
	SHOULD_BUILD_SECURITY_ID_AS_DEFAULT_IDENTIFIER = 'SHOULD_BUILD_SECURITY_ID_AS_DEFAULT_IDENTIFIER',
	SHOULD_IGNORE_EMPTY_PAS_SLEEVE = 'SHOULD_IGNORE_EMPTY_PAS_SLEEVE', // temp key until suppressZeroContributors works on AWA side

	// Proposal
	PROPOSAL_METRIC_MAPPING = 'PROPOSAL_METRIC_MAPPING',
	PROPOSAL_PURPOSE_RISK_TOLERANCE_OPTIONS = 'PROPOSAL_PURPOSE_RISK_TOLERANCE_OPTIONS',
	PROPOSAL_PURPOSE_OBJECTIVE_OPTIONS = 'PROPOSAL_PURPOSE_OBJECTIVE_OPTIONS',
	PROPOSAL_ALLOCATION_METRIC_MAX_ASSET_CLASSES_CHANGES = 'PROPOSAL_ALLOCATION_METRIC_MAX_ASSET_CLASSES_CHANGES',

	// Unorganized ones, need to organize accordingly:
	DATE_FORMAT = 'DATE_FORMAT',
	ENABLE_EUROPEAN_DATE = 'ENABLE_EUROPEAN_DATE',
	HAS_COLLAPSED_DISCLOSURE = 'HAS_COLLAPSED_DISCLOSURE',
	MAX_DEPTH = 'MAX_DEPTH',
	SHOULD_SHOW_BENCHMARK_OPTION = 'SHOULD_SHOW_BENCHMARK_OPTION',
	SHOULD_SHOW_BLEND_OPTION = 'SHOULD_SHOW_BLEND_OPTION',
	SHOW_ADD_CUSTOM_PAGE = 'SHOW_ADD_CUSTOM_PAGE',
	SHOW_PDF_FRONT_DISCLOSURE = 'SHOW_PDF_FRONT_DISCLOSURE',
	SHOW_PDF_REORDERING = 'SHOW_PDF_REORDERING',
	TOUR_DIALOG_MAX_STEPS = 'TOUR_DIALOG_MAX_STEPS',
	SUPPORTED_FUND_TAGS = 'SUPPORTED_FUND_TAGS',
	SUPPORTED_FUND_STATUS_INTERACTIONS = 'SUPPORTED_FUND_STATUS_INTERACTIONS',
	MAXIMUM_TAGS_PER_FUND = 'MAXIMUM_TAGS_PER_FUND',
	MAXIMUM_TAGGED_FUNDS = 'MAXIMUM_TAGGED_FUNDS',
	MAXIMUM_STATUS_INTERACTIONS_PER_FUND = 'MAXIMUM_STATUS_INTERACTIONS_PER_FUND',
	MAXIMUM_STATUS_INTERACTIONS = 'MAXIMUM_STATUS_INTERACTIONS',
	MAXIMUM_PORTFOLIOS_TO_ANALYZE = 'MAXIMUM_PORTFOLIOS_TO_ANALYZE',
	MAXIMUM_PORTFOLIOS_CHILDREN = 'MAXIMUM_PORTFOLIOS_CHILDREN',
	SUPPORTED_PORTFOLIO_TAGS = 'PORTFOLIO_TAGS',
	PORTFOLIO_TAG_VISIBLE_LIMIT = 'PORTFOLIO_TAG_VISIBLE_LIMIT',
	PC_CURRENCY_SELECTION_OPTIONS = 'PC_CURRENCY_SELECTION_OPTIONS',
	USE_WWE_SECURITY_ENRICHER = 'USE_WWE_SECURITY_ENRICHER',
	WWE_RC_TENANT_OVERRIDES = 'WWE_RC_TENANT_OVERRIDES',
	PAS_RC_TENANT_OVERRIDES = 'PAS_RC_TENANT_OVERRIDES',
	PAS_RC_ENV_OVERRIDES = 'PAS_RC_ENV_OVERRIDES',
	CWP_COMPONENTS = 'CWP_COMPONENTS',
	IDENTIFIER_TO_BE_USED_AS_WWE_API_PARAM_ID = 'IDENTIFIER_TO_BE_USED_AS_WWE_API_PARAM_ID',
	SHOW_FIXED_INCOME_RISK_SLEEVE = 'SHOW_FIXED_INCOME_RISK_SLEEVE',
	SHOW_FIXED_INCOME_ATTRIBUTES = 'SHOW_FIXED_INCOME_ATTRIBUTES',
	SHOW_MULTI_ASSET_RISK_SLEEVE = 'SHOW_MULTI_ASSET_RISK_SLEEVE',
	SHOW_ALTERNATIVES_RISK_SLEEVE = 'SHOW_ALTERNATIVES_RISK_SLEEVE',
	SHOW_TAIL_RISK_SLEEVE = 'SHOW_TAIL_RISK_SLEEVE',
	SHOW_SECURITY_RISK_CONTRIBUTIONS = 'SHOW_SECURITY_RISK_CONTRIBUTIONS',
	ENABLE_ADAM_MODEL_NAMES = 'ENABLE_ADAM_MODEL_NAMES',
	ENABLE_CMS_RENAMING = 'ENABLE_CMS_RENAMING',
	ENABLE_EXTSSO_CHECK = 'ENABLE_EXTSSO_CHECK',
	DISPLAY_COMPONENT_CONFIG = 'DISPLAY_COMPONENT_CONFIG',
	CUSTOM_ADVISORY_FEE = 'CUSTOM_ADVISORY_FEE',
	SHOW_360_EVALUATOR_LINK = 'SHOW_360_EVALUATOR_LINK',
	ENABLE_TAX_MIGRATION = 'ENABLE_TAX_MIGRATION',
	MONITORING_MENU_ACTIONS = 'MONITORING_MENU_ACTIONS',
	SHOW_RISK_CONTRIBUTION_MODAL = 'SHOW_RISK_CONTRIBUTION_MODAL',
	ENABLE_SCENARIO_ADVISORY_FEE = 'ENABLE_SCENARIO_ADVISORY_FEE',
	SHOW_ROLLING_PERFORMANCE = 'SHOW_ROLLING_PERFORMANCE',
	MAXIMUM_FUND_PREFERENCE_CHILDREN_TO_UPDATE = 'MAXIMUM_FUND_PREFERENCE_CHILDREN_TO_UPDATE',
	SHOW_CORRELATION_MATRIX = 'SHOW_CORRELATION_MATRIX',
	SHOULD_GET_COMMON_PERIOD = 'SHOULD_GET_COMMON_PERIOD',
	ENABLE_TPM_FOR_DOT_COM = 'ENABLE_TPM_FOR_DOT_COM',
	ENABLE_THIRD_PARTY_API = 'ENABLE_THIRD_PARTY_API',
	ENABLE_CUSTOM_MODELS_API = 'ENABLE_CUSTOM_MODELS_API',
	FETCH_TAX_DETAILS = 'FETCH_TAX_DETAILS',
	SHOULD_THROW_SECURITY_DETAILS_PARTIAL_ERROR = 'SHOULD_THROW_SECURITY_DETAILS_PARTIAL_ERROR',
	ASSET_CLASS_LIST = 'ASSET_CLASS_LIST',
	ENABLE_WORST_TAX_OFFENDERS = 'ENABLE_WORST_TAX_OFFENDERS',
	FUND_PERF_DEFAULT_PAGE_SIZE = 'FUND_PERF_DEFAULT_PAGE_SIZE',
	FEES_DEFAULT_PAGE_SIZE = 'FEES_DEFAULT_PAGE_SIZE',
	SHOULD_LOAD_MODEL_FAMILIES_FROM_IRETIRE_SERVER = 'SHOULD_LOAD_MODEL_FAMILIES_FROM_IRETIRE_SERVER',
	SHOULD_USE_DAS_PORTFOLIO_ID = 'SHOULD_USE_DAS_PORTFOLIO_ID',
	BLK_IDEAS_MORNINGSTAR_CATEGORY_MAPPING = 'BLK_IDEAS_MORNINGSTAR_CATEGORY_MAPPING',
	SHOW_STOCK_STYLE = 'SHOW_STOCK_STYLE',
	ENABLE_HARD_STOP_WITH_PE = 'ENABLE_HARD_STOP_WITH_PE',
	FLIP_MODELS_CONFIG_STORE_IDENTIFIER_TO_DAS_PORTFOLIO_ID = 'FLIP_MODELS_CONFIG_STORE_IDENTIFIER_TO_DAS_PORTFOLIO_ID',
	SHOULD_ADD_BENCHMARK_PERF_ANALYSIS_AT_ROOT = 'SHOULD_ADD_BENCHMARK_PERF_ANALYSIS_AT_ROOT',
	SHOULD_LOAD_MODEL_FAMILIES_FROM_WDS_CONFIG_IN_IRETIRE = 'SHOULD_LOAD_MODEL_FAMILIES_FROM_WDS_CONFIG_IN_IRETIRE',
	USE_PAS_FOR_IRETIRE_INCOME_CALCULATION = 'USE_PAS_FOR_IRETIRE_INCOME_CALCULATION',
	DEFAULT_LOCALE = 'DEFAULT_LOCALE',
	ENABLE_PAS_THIRD_PARTY_API = 'ENABLE_PAS_THIRD_PARTY_API',
	CHECK_BLENDS = 'CHECK_BLENDS',
}

export enum DashboardConfigKey {
	ANALYSIS_OPTIONS = 'DASHBOARD.analysisOptions',
	PORTFOLIO_LIBRARY_COL_ACTIONS = 'DASHBOARD.portfolioLibraryColActions',
	SHOW_CURRENCY_DROPDOWN = 'DASHBOARD.showCurrencyDropdown',
	SHOW_INDEX_DROPDOWN = 'DASHBOARD.showIndexDropdown',
	SHOW_REPLACE_MODEL = 'DASHBOARD.showReplaceModel',
	DYNAMIC_HOLDINGS_TABLE = 'DASHBOARD.dynamicHoldingsTable',
	PREVIEW_HOLDINGS_TABLE_HEADERS = 'DASHBOARD.previewHoldingsTableHeaders',
	DEFAULT_BENCHMARK = 'DASHBOARD.defaultBenchmark',
	DEFAULT_CURRENCY = 'DASHBOARD.defaultCurrency',
	SHOULD_SNAPSHOT_SHOW_COST = 'DASHBOARD.shouldSnapshotShowCost',
	SHOW_ANALYSIS_ACTIONS_DRAWER = 'DASHBOARD.showAnalysisActionsDrawer',
	SNAPSHOT_TAB_LIST = 'DASHBOARD.snapshotTabList',
	TPW_EDITOR_PORTFOLIO_TYPES = 'DASHBOARD.tpwEditorPortfolioTypes',
	ENABLE_CUSTOM_FEE = 'DASHBOARD.customFeeEnabled',
	SHOW_INCEPTION_DATE = 'DASHBOARD.showInceptionDate',
	DISABLE_PREVIEW = 'DASHBOARD.disablePreview',
	MAX_COMPARE_LIMIT = 'DASHBOARD.maxCompareLimit',
	MAX_MONITORING_LIMIT = 'DASHBOARD.maxMonitoringLimit',
	BFA_TABLE_HEADERS = 'DASHBOARD.bfaTableHeaders',
	BFA_TABLE_ACTIONS = 'DASHBOARD.bfaTableActions',
	BFA_TABLE_PAGE_SIZE = 'DASHBOARD.bfaTablePageSize',
	BFA_ENABLE_NEW_DASHBOARD = 'DASHBOARD.bfaEnableNewDashboard',
	SHOW_GETTING_STARTED = 'DASHBOARD.showGettingStarted'
}

/**
 * AC Portfolio Library - Config Keys
 * currently is just for show/hide the tab routing on ACPL landing page component
 * TODO dluong: figure out where to put this properly
 */
export enum ACPortfolioLibraryConfigKey {
	SHOW_MONITORING = 'SHOW_MONITORING',
	DISABLE_MONITORING_HARD_STOP = 'DISABLE_MONITORING_HARD_STOP'
}

export enum PdfSharedConfigKey {
	ACT_33_ENABLED = 'PDF.ACT_33_ENABLED',
	REPORT_DOWNLOAD_SHOW_PRIVACY_DISCLAIMER = 'PDF.REPORT_DOWNLOAD_SHOW_PRIVACY_DISCLAIMER',
	ENABLE_PDF_ACTIONS_DRAWER = 'PDF.ENABLE_PDF_ACTIONS_DRAWER',
	USE_CLIENT_NAME_FOR_FILENAME = 'PDF.USE_CLIENT_NAME_FOR_FILENAME',
	ENABLE_YIELD = 'PDF.ENABLE_YIELD',
	ENABLE_CUSTOMIZATION = 'PDF.ENABLE_CUSTOMIZATION',
	IS_REPORT_FIRM_NAME_READONLY = 'PDF.IS_REPORT_FIRM_NAME_READONLY',
	IS_REPORT_NAME_READONLY = 'PDF.IS_REPORT_NAME_READONLY',
	SHOULD_SHOW_FIRM_NAME_INPUT = 'PDF.SHOULD_SHOW_FIRM_NAME_INPUT',
	SHOULD_SHOW_STATUS_FILTERING = 'SHOULD_SHOW_STATUS_FILTERING',
	SHOW_COBRANDING_DISCLOSURE = 'SHOW_COBRANDING_DISCLOSURE'
}

/**
 * Portfolio Analyser - 360 Evaluator - Config Keys
 */
export enum PaConfigKey {
	ShouldShowCloneOption = 'SHOULD_SHOW_CLONE_OPTION',
	SelfServicePdfButtonVisibility = 'SELF_SERVICE_PDF_BUTTON_VISIBILITY',
	ShowHoldingsCharacteristicsNavLink = 'SHOW_HOLDINGS_CHARACTERISTICS_NAV_LINK',
	EsgIndustryInvolvement = 'ESG_INDUSTRY_INVOLVEMENT_METRICS',
	ShouldFetchSecurityDataForAllApbPositions = 'SHOULD_FETCH_SECURITY_DATA_FOR_ALL_APB_POSITIONS',
	ATE_MIN_TAX_SAVINGS_LIMIT = 'ATE_MIN_TAX_SAVINGS_LIMIT',
	COST_IMPACT_CHART_DEFAULTS = 'COST_IMPACT_CHART_DEFAULTS',
	SHOW_EXPLORE_IQ_BUTTON = 'SHOW_EXPLORE_IQ_BUTTON',
	SHOW_SEND_TO_ENVESTNET_LINK = 'SHOW_SEND_TO_ENVESTNET_LINK',
	SHOW_SCENARIO_TESTER_LINK = 'SHOW_SCENARIO_TESTER_LINK',
	SHOW_TAX_EVALUATOR_LINK = 'SHOW_TAX_EVALUATOR_LINK',
	ENABLE_NEW_MSCI_SCORE_CALCULATION = 'ENABLE_NEW_MSCI_SCORE_CALCULATION',
	CAP_OVERRIDE_DATE = 'CAP_OVERRIDE_DATE',
	ENABLE_CAP_OVERRIDE_DATE = 'ENABLE_CAP_OVERRIDE_DATE',
	PEER_COMPARISON_CONFIG = 'PEER_COMPARISON_CONFIG',
	SHOW_IMPORT_PARTNER_PORTFOLIO = 'SHOW_IMPORT_PARTNER_PORTFOLIO',
	PARTNER_PLATFORM_CONTROLS_LIST = 'IPP.PARTNER_PLATFORM_CONTROLS_LIST',
	MAX_PORTFOLIO_SELECTION_LIMIT = 'IPP.MAX_PORTFOLIO_SELECTION_LIMIT',
	SHOW_MEGATRENDS_COMPONENT = 'SHOW_MEGATRENDS_COMPONENT',

	// Header buttons
	HIDE_PROPOSAL_REPORT_BUTTON = 'HIDE_PROPOSAL_REPORT_BUTTON',
	ENABLE_PROPOSAL_VIEW = 'ENABLE_PROPOSAL_VIEW',
	SHOW_DOWNLOAD_HOLDINGS_BUTTON = 'SHOW_DOWNLOAD_HOLDINGS_LINK',
	SHOW_CLIENT_REPORT_BUTTON = 'SHOW_CLIENT_REPORT_BUTTON',
	SHOW_ADVISOR_REPORT_PS_BUTTON = 'SHOW_ADVISOR_REPORT_PS_BUTTON',
	SHOW_ADVISOR_REPORT_SS_BUTTON = 'SHOW_ADVISOR_REPORT_SS_BUTTON',
	ENABLE_FUND_STATS = 'ENABLE_FUND_STATS',
	HEADER_CONFIGURATION = 'HEADER_CONFIGURATION',
	NOT_VISIBLE_PORTFOLIO_ACTIONS_KEYS = 'NOT_VISIBLE_PORTFOLIO_ACTIONS_KEYS',
	MUNICIPAL_BOND_MORNINGSTAR_CATEGORIES = 'MUNICIPAL_BOND_MORNINGSTAR_CATEGORIES',
	DERIVATIVES_AND_OPTIONS_MORNINGSTAR_CATEGORIES = 'DERIVATIVES_AND_OPTIONS_MORNINGSTAR_CATEGORIES',
	FTE_FUNDS_TO_REPLACE_STATUS_COLOURS = 'FTE_FUNDS_TO_REPLACE_STATUS_COLOURS'
}

/**
 * Portfolio Editor Config Keys
 */
export enum PeConfigKey {
	/**
	 * Used ONLY for quick import
	 */
	MAX_HOLDINGS_QUICK_IMPORT = 'PORTFOLIO_EDITOR.maxHoldingsQuickImport',

	/**
	 * Used in tax tool for list of holdings support
	 */
	MAX_HOLDINGS_LOH_SIZE = 'PORTFOLIO_EDITOR.maxHoldingsLOHSize',

	/**
	 * Any portfolio type except LoH
	 */
	MAX_HOLDINGS = 'PORTFOLIO_EDITOR.maxHoldings',

	DISABLE_ERROR_HANDLING = 'PE_DISABLE_ERROR_HANDLING', // temporary
	PE_IMPORT_POSSIBLE_IDENTIFIERS = 'PORTFOLIO_EDITOR.importPossibleIdentifiers',
	CHECK_CASH_TICKER = 'PORTFOLIO_EDITOR.checkCashTicker',
	ALLOW_MULTI_HEADER_IMPORT = 'PORTFOLIO_EDITOR.allowMultiHeaderImport',
	USE_FACETS = 'PORTFOLIO_EDITOR.useFacets',
	USE_HOLDINGS_RESOLUTION_PAGE = 'PORTFOLIO_EDITOR.useHoldingsResolutionPage',
	SHOULD_DEFER_PORTFOLIO_SAVE = 'PORTFOLIO_EDITOR.shouldDeferPortfolioSave',
	PRODUCT_TYPES_TO_REMOVE = 'PORTFOLIO_EDITOR.productTypesToRemove',
	USE_KPI = 'PORTFOLIO_EDITOR.useKpi',
	HOLDINGS_ERROR_WEIGHT_TOLERANCE = 'PORTFOLIO_EDITOR.holdingsErrorWeightTolerance',
	ENABLE_PORTFOLIO_NAME_INSTRUCTION = 'PORTFOLIO_EDITOR.isPortfolioNameInstructionEnabled',
	PORTFOLIO_NAME_MAX_SIZE = 'PORTFOLIO_EDITOR.portfolioNameMaxSize',
	ENABLE_AUTO_ALLOCATION = 'PORTFOLIO_EDITOR.enableAutoAllocation',
	COMPARE_ALADDIN_ID = 'PORTFOLIO_EDITOR.compareAladdinId',
	SHOW_IMPORT_OPTIONS = 'PORTFOLIO_EDITOR.showImportOptions',
	SORTABLE_HEADERS = 'PORTFOLIO_EDITOR.sortableHeaders',
	SHOW_TICKER_ONLY = 'PORTFOLIO_EDITOR.showTickerOnly',
	HOLDING_WEIGHT_LIMIT = 'PORTFOLIO_EDITOR.holdingWeightLimit',
	MIN_HOLDINGS = 'PORTFOLIO_EDITOR.minHoldings',
	HIDE_AMOUNT = 'PORTFOLIO_EDITOR.hideAmount',
	SHOW_DELIMITER_TOGGLE = 'PORTFOLIO_EDITOR.showDelimiterToggle',
	RESTRICT_NESTED_PORTFOLIOS = 'PORTFOLIO_EDITOR.restrictNestedPortfolios',
	PORTFOLIO_TYPE_OPTIONS = 'PORTFOLIO_EDITOR.portfolioTypeOptions',
	USE_MULTI_IDENTIFIER_PASTE = 'PORTFOLIO_EDITOR.useMultiIdentifierPaste',
	SHOW_HOLDINGS_EDITOR_VIEW_TOGGLE = 'PORTFOLIO_EDITOR.showHoldingsEditorViewToggle',
	MAX_HOLDINGS_QP = 'PORTFOLIO_EDITOR.maxHoldingsFromQueryParam',
	PORTFOLIO_CHILD_TYPE_OPTIONS = 'PORTFOLIO_EDITOR.portfolioChildTypeOptions',
	SHOW_ONLY_CLEAR_HOLDINGS_ACTION = 'PORTFOLIO_EDITOR.showOnlyClearHoldingsAction',
	SHOULD_ALIGN_ERRORS = 'PORTFOLIO_EDITOR.shouldAlignErrors',
	SHOW_TAX_EXEMPT_CHECKBOX = 'PORTFOLIO_EDITOR.showTaxExemptCheckbox',
	SHOW_IMPORT_LINK = 'PORTFOLIO_EDITOR.showImportLink',
	IMPORT_HEADERS = 'PORTFOLIO_EDITOR.IMPORT_HEADERS',
	WEIGHT_INPUT_DEBOUNCE_TIME = 'PORTFOLIO_EDITOR.weightInputDebounceTime',
	USE_MODELS = 'PORTFOLIO_EDITOR.useModels',
	USE_LOCALE_DELIMITER = 'PORTFOLIO_EDITOR.useLocaleDelimiter',
	ASSET_SEARCH_NEGATE_FILTERS = 'PORTFOLIO_EDITOR.assetSearchNegateFilters',
	ASSET_SEARCH_RESULTS_COUNT = 'PORTFOLIO_EDITOR.assetSearchResultsCount',
	ASSET_SEARCH_EXCLUDE_ALTS = 'PORTFOLIO_EDITOR.assetSearchExcludeAlts',
	PRODUCT_TYPES_TO_ADD = 'PORTFOLIO_EDITOR.productTypesToAdd',
	USE_STANDALONE_PE = 'USE_STANDALONE_PE', // TODO dbuddha: temporary support for wds decom to support standalone PE
	RULE_ENABLE_CASH = 'RULE_ENABLE_CASH',
	RULE_ENABLE_DUPLICATE_MSTAR = 'RULE_ENABLE_DUPLICATE_MSTAR'
}

export enum PcConfigKey {
	PC_BENCHMARK_SELECTION_OPTIONS = 'PC_BENCHMARK_SELECTION_OPTIONS',
	SHOW_INSIGHTS_BENCHMARK_HEADER = 'SHOW_INSIGHTS_BENCHMARK_HEADER',
	SHOW_INSIGHTS_BII_VIEW_PDF = 'SHOW_INSIGHTS_BII_VIEW_PDF',
	SHOW_INSIGHTS_INDICATOR_CHART_DISCLAIMER = 'SHOW_INSIGHTS_INDICATOR_CHART_DISCLAIMER',
	SHOW_INSIGHTS_PEER_COMPARISON = 'SHOW_INSIGHTS_PEER_COMPARISON',
	SHOW_INSIGHTS_STRATEGIES_PDF = 'SHOW_INSIGHTS_STRATEGIES_PDF',
	SHOULD_VALIDATE_PORTFOLIO_FOR_INSIGHTS = 'SHOULD_VALIDATE_PORTFOLIO_FOR_INSIGHTS',
	BPAS_CURRENCY_SELECTION_OPTIONS = 'BPAS_CURRENCY_SELECTION_OPTIONS',
	ENABLE_NOT_ACTIVE_ENGAGEMENT_POPUP = 'ENABLE_NOT_ACTIVE_ENGAGEMENT_POPUP',
	SHOW_AS_OF_DATE_DYNAMIC = 'SHOW_AS_OF_DATE_DYNAMIC',
	SHARING_MAX_USERS = 'SHARING_MAX_USERS',
	CURRENCY_EXPOSURES_THRESHOLD = 'CURRENCY_EXPOSURES_THRESHOLD',
	MAX_PORTFOLIOS_PER_PAGE = 'MAX_PORTFOLIOS_PER_PAGE',
	MAX_CHARACTER_LIMIT_FOR_PRODUCT_NAME_IN_TOOLTIP = 'MAX_CHARACTER_LIMIT_FOR_PRODUCT_NAME_IN_TOOLTIP',
	SHOW_FX_RISK_CONTRIBUTION = 'SHOW_FX_RISK_CONTRIBUTION',
	CORRELATION_MATRIX_FUNDS_COUNT = 'CORRELATION_MATRIX_FUNDS_COUNT',
	ENABLE_NEW_CLIENT_REPORT_FUNCTIONALITY = 'ENABLE_NEW_CLIENT_REPORT_FUNCTIONALITY',
	ENABLE_CURRENCY_EXPOSURES = 'ENABLE_CURRENCY_EXPOSURES',
	ENABLE_BLENDING = 'ENABLE_BLENDING'
}

export enum CmaConfigKey {
	STRATEGY_SOURCE_FROM_FALLBACK = 'STRATEGY_SOURCE_FROM_FALLBACK',
	SHOW_STRATEGY_GROUP_FILTER = 'SHOW_STRATEGY_GROUP_FILTER'
}

export enum IqConfigKey {
	FUND_ANALYTICS_TABS = 'FUND_ANALYTICS_TABS',
	CHART_COLOR_PER_STATUS = 'CHART_COLOR_PER_STATUS',
	AOF_DATA_CORRELATION = 'AOF_DATA_CORRELATION',
	EXPOSURE_ALLOCATION_DATA_CORRELATION = 'EXPOSURE_ALLOCATION_DATA_CORRELATION',
	ENABLE_FUND_TAGGING = 'ENABLE_FUND_TAGGING',
	MORNINGSTAR_CATEGORY_ORDER = 'MORNINGSTAR_CATEGORY_ORDER',
	FLYOUT_MAX_PORTFOLIO_NAME_LENGTH = 'FLYOUT_MAX_PORTFOLIO_NAME_LENGTH',
	FLYOUT_MAX_PORTFOLIOS_IN_DROPDOWN = 'FLYOUT_MAX_PORTFOLIOS_IN_DROPDOWN',
	HEADER_BUTTON_EDIT_PORTFOLIO = 'HEADER_BUTTON_EDIT_PORTFOLIO',
	HEADER_BUTTON_NEW_ANALYSIS = 'HEADER_BUTTON_NEW_ANALYSIS',
	HEADER_BUTTON_EDIT_ANALYSIS = 'HEADER_BUTTON_EDIT_ANALYSIS',
	HEADER_BUTTON_DOWNLOAD_ANALYSIS = 'HEADER_BUTTON_DOWNLOAD_ANALYSIS',
	SHOW_TAX_ESTIMATES = 'SHOW_TAX_ESTIMATES',
	SHOW_TAX_QUALIFIED_PORTFOLIOS_NOTIFICATION = 'SHOW_TAX_QUALIFIED_PORTFOLIOS_NOTIFICATION',
	ENABLE_STATUS_CHANGES = 'ENABLE_STATUS_CHANGES',
	SHOW_NO_TAG_FILTER_CHECKBOX = 'SHOW_NO_TAG_FILTER_CHECKBOX',
	ENABLE_FUND_STATUS_INTERACTIONS = 'ENABLE_FUND_STATUS_INTERACTIONS',
	ENABLE_FUND_TAGS = 'ENABLE_FUND_TAGS',
	ENABLE_IQ_BUY_FUNDS = 'ENABLE_IQ_BUY_FUNDS',
	COMPARE_OVERRIDE_DATE = 'COMPARE_OVERRIDE_DATE'
}

export enum TaxConfigKey {
	SHOW_REPORT_CAP_GAIN_TOGGLE = 'SHOW_REPORT_CAP_GAIN_TOGGLE',
	ESTIMATED_CAPITAL_GAIN_STATUSES_ORDER = 'ESTIMATED_CAPITAL_GAIN_STATUSES_ORDER',
	ESTIMATES_LOOK_BACK_PERIOD = 'ESTIMATES_LOOK_BACK_PERIOD',
	SHOW_NEW_BADGE = 'SHOW_NEW_BADGE'
}

export enum FundStatsConfigKey {
	STATUSES = 'statuses',
	STATUS_CHANGES = 'statusChanges',
	DIMENSIONS = 'dimensions',
	SHOULD_AGGREGATE_FUND_STATS = 'SHOULD_AGGREGATE_FUND_STATS'
}

export enum IretireAccumConfigKey {
	SIDENAV_DISPLAY_CONFIG = 'SIDENAV_DISPLAY_CONFIG',
	CMA_TABLE_CONFIG = 'CMA_TABLE_CONFIG',
	URL_TO_CLIENT_SLICES_MAPPING = 'URL_TO_CLIENT_SLICES_MAPPING',
	PARAMS_TO_ACCESS_RESULTS = 'PARAMS_TO_ACCESS_RESULTS',
	PARAMS_TO_ACCESS_ANNUITY_RESULTS = 'PARAMS_TO_ACCESS_ANNUITY_RESULTS'
}

export enum IretireDecumConfigKey {
	SIDENAV_DISPLAY_CONFIG = 'SIDENAV_DISPLAY_CONFIG',
	CMA_TABLE_CONFIG = 'CMA_TABLE_CONFIG',
	URL_TO_CLIENT_SLICES_MAPPING = 'URL_TO_CLIENT_SLICES_MAPPING',
	PARAMS_TO_ACCESS_RESULTS = 'PARAMS_TO_ACCESS_RESULTS'
}

export enum ModelsExperienceConfigKey {
	HIGHLIGHTED_FILTERS = 'HIGHLIGHTED_FILTERS_ICON',
	MODELS_DISPLAY_ORDER_ON_SLIDER_ON_RISK_PROFILE = 'MODELS_DISPLAY_ORDER_ON_SLIDER_ON_RISK_PROFILE',
	RISK_PROFILE_SORT_ORDER = 'RISK_PROFILE_SORT_ORDER',
	EXPLORE_CARD_FILTERS = 'EXPLORE_CARD_FILTERS',
	HOME_PAGE_LEFT_NAV = 'HOME_PAGE_LEFT_NAV',
	HOME_PAGE_SELECTED_CARD_FAMILIES_PER_CATEGORY = 'HOME_PAGE_SELECTED_CARD_FAMILIES_PER_CATEGORY',
	DROP_DOWN_FILTERS = 'DROP_DOWN_FILTERS',
	DROPDOWN_FILTER_MAPPING = 'DROPDOWN_FILTER_MAPPING',
	SHOW_DOWNLOAD_HOLDINGS_BUTTON_ON_FIND_AND_COMPARE = 'SHOW_DOWNLOAD_HOLDINGS_BUTTON_ON_FIND_AND_COMPARE',
	SHOW_DOWNLOAD_HOLDINGS_BUTTON = 'SHOW_DOWNLOAD_HOLDINGS_BUTTON',
	ENABLE_DOWNLOAD_HOLDINGS_MODULARITY = 'ENABLE_DOWNLOAD_HOLDINGS_MODULARITY',
	SHOW_DOWNLOAD_ALL_PDF_BUTTON = 'SHOW_DOWNLOAD_ALL_PDF_BUTTON',
	MODEL_CATEGORY_MAPPING = 'MODEL_CATEGORY_MAPPING',
	PDF_INVESTMENT_PAGES_MAPPING = 'PDF_INVESTMENT_PAGES_MAPPING',
	PERFORMANCE_BOX_DISCLOSURE_ENABLED_FOR_BLK_GROUP_FAMILY = 'PERFORMANCE_BOX_DISCLOSURE_ENABLED_FOR_BLK_GROUP_FAMILY',
	ENABLE_FAMILY_SPECIFIC_PERFORMANCE_BENCHMARK_DISCLOSURE = 'ENABLE_FAMILY_SPECIFIC_PERFORMANCE_BENCHMARK_DISCLOSURE',
	BENCHMARK_ESG_SCORE = 'BENCHMARK_ESG_SCORE',
	ESG_SCORE = 'ESG_SCORE',
	ENABLE_ROUND_OFF_EQUIVALENCY_SCORE = 'ENABLE_ROUND_OFF_EQUIVALENCY_SCORE',
	ENABLE_COMMENTARY_KEYS_MAPPING = 'ENABLE_COMMENTARY_KEYS_MAPPING',
	SHOW_MODEL_OVERVIEW_PDF_PAGE = 'SHOW_MODEL_OVERVIEW_PDF_PAGE',
	SHOW_INVESTMENT_PDF_PAGES = 'SHOW_INVESTMENT_PDF_PAGES',
	SHOW_ESG_PDF_PAGES = 'SHOW_ESG_PDF_PAGES',
	SHOW_PDF_GLOSSARY_PAGE = 'SHOW_PDF_GLOSSARY_PAGE',
	SHOW_PDF_MODULARITY = 'SHOW_PDF_MODULARITY',
	SHOW_CMS_PDF_MODULARITY = 'SHOW_CMS_PDF_MODULARITY',
	SHOW_PDF_TRADE_RATIONALE_IMG = 'SHOW_PDF_TRADE_RATIONALE_IMG',
	ENABLE_ADD_TO_COMPARE_MODEL = 'ENABLE_ADD_TO_COMPARE_MODEL',
	ME_AS_OF_DATE = 'ME_AS_OF_DATE',
	PERFORMANCE_AS_OF_DATE = 'PERFORMANCE_AS_OF_DATE',
	SHOW_FUND_PERF_TABLE_LINK = 'SHOW_FUND_PERF_TABLE_LINK',
	ENABLE_PERFORMANCE_BENCHMARK = 'ENABLE_PERFORMANCE_BENCHMARK',
	PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST = 'PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST',
	PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST_PDF = 'PERFORMANCE_TABLE_DISABLE_COLUMNS_LIST_PDF',
	PERFORMANCE_TABLE_COLUMN_WIDTH = 'PERFORMANCE_TABLE_COLUMN_WIDTH',
	LATEST_HOLDINGS_HEADER_COLUMNS = 'LATEST_HOLDINGS_HEADER_COLUMNS',
	CHANGES_TO_HOLDINGS_HEADER_COLUMNS = 'CHANGES_TO_HOLDINGS_HEADER_COLUMNS',
	ESG_RATING_MAPPING = 'ESG_RATING_MAPPING',
	MODEL_FAMILIES_V2_1_API_ENABLE = 'MODEL_FAMILIES_V2_1_API_ENABLE',
	SHOW_DROPDOWN_FILTERS_MORE_LESS_BUTTON = 'SHOW_DROPDOWN_FILTERS_MORE_LESS_BUTTON',
	SHOW_SEARCH_BUTTON = 'SHOW_SEARCH_BUTTON',
	SHOW_MODELS_COMPARISON_CHECKBOX = 'SHOW_MODELS_COMPARISON_CHECKBOX',
	SHOW_RISK_INDICATOR = 'SHOW_RISK_INDICATOR',
	SHOW_ANALYSIS_BUTTON = 'SHOW_ANALYSIS_BUTTON',
	RISK_PROFILE_KEYS = 'RISK_PROFILE_KEYS',
	FAMILY_DETAILS_TAB = 'FAMILY_DETAILS_TAB',
	MULTI_ROW_LEFT_HEADER = 'MULTI_ROW_LEFT_HEADER',
	ENABLE_HOLDINGS_TABLE_HEADER_V2 = 'ENABLE_HOLDINGS_TABLE_HEADER_V2',
	HOLDINGS_TABLE_HEADER_COLUMNS = 'HOLDINGS_TABLE_HEADER_COLUMNS',
	SHOW_MODEL_LIST_DISCLOSURE = 'SHOW_MODEL_LIST_DISCLOSURE',
	SHOW_FAMILY_LIST_HEADER_DISCLOSURE = 'SHOW_FAMILY_LIST_HEADER_DISCLOSURE',
	SHOW_MODEL_LIST_PERFORMANCE_DISCLOSURE = 'SHOW_MODEL_LIST_PERFORMANCE_DISCLOSURE',
	SHOW_FAMILY_DESCRIPTION = 'SHOW_FAMILY_DESCRIPTION',
	ENABLE_PORTFOLIO_LINKS = 'ENABLE_PORTFOLIO_LINKS',
	ENABLE_NET_PERFORMANCE = 'ENABLE_NET_PERFORMANCE',
	ENABLE_PERFORMANCE_PAGE_BOTTOM_DISCLOSURE = 'ENABLE_PERFORMANCE_PAGE_BOTTOM_DISCLOSURE',
	ENABLE_PERFORMANCE_BOX_DISCLOSURE = 'ENABLE_PERFORMANCE_BOX_DISCLOSURE',
	DATE_FORMAT = 'DATE_FORMAT',
	ENABLE_HOLDINGS_TABLE_HEADER_COLUMN_WIDTH = 'ENABLE_HOLDINGS_TABLE_HEADER_COLUMN_WIDTH',
	CACHE_BUSTER_ENFORCED = 'CACHE_BUSTER_ENFORCED',
	CACHE_BUSTER_MINUTES = 'CACHE_BUSTER_MINUTES',
	MODELS_PUBLIC_API_TS_PATH = 'MODELS_PUBLIC_API_TS_PATH',
	MODELS_PUBLIC_API_TS_PATH_PREVIEW = 'MODELS_PUBLIC_API_TS_PATH_PREVIEW',
	USE_H1_TITLE_PDF = 'USE_H1_TITLE_PDF',
	LEFT_ALIGNED_COLUMNS_INDEX = 'LEFT_ALIGNED_COLUMNS_INDEX',
	EQUITIES_ASSET_CLASSES = 'EQUITIES_ASSET_CLASSES',
	FIXED_INCOME_ASSET_CLASSES = 'FIXED_INCOME_ASSET_CLASSES',
	SHOW_BRAND_AND_SHARE_LINK = 'SHOW_BRAND_AND_SHARE_LINK',
	PDF_RISK_PROFILE_MODULARITY_FAMILIES = 'PDF_RISK_PROFILE_MODULARITY_FAMILIES',
	SHOW_PDF_MODULARITY_FOOTNOTE = 'SHOW_PDF_MODULARITY_FOOTNOTE',
	DISABLE_COVER_PAGE_IMAGE = 'DISABLE_COVER_PAGE_IMAGE',
	ENABLE_PDF_HOLDINGS_HEADER_WRAPPING = 'ENABLE_PDF_HOLDINGS_HEADER_WRAPPING',
	HIDE_LATEST_ALLOCATION_FAMILY_LIST = 'HIDE_LATEST_ALLOCATION_FAMILY_LIST',
	PERFORMANCE_COMMENTARY_ENABLED_FOR_CMS = 'PERFORMANCE_COMMENTARY_ENABLED_FOR_CMS',
	DOWNLOAD_EXCEL_FAMILY_LIMIT = 'DOWNLOAD_EXCEL_FAMILY_LIMIT',
	DISABLE_360_LINKAGE = 'DISABLE_360_LINKAGE',
	MINI_COMPARE_TABLE_DATA_POINTS_LIST = 'MINI_COMPARE_TABLE_DATA_POINTS_LIST',
	MINI_COMPARE_TABLE_GROSS_DATA_POINTS = 'MINI_COMPARE_TABLE_GROSS_DATA_POINTS',
	SHOW_STATIC_BANNER = 'SHOW_STATIC_BANNER',
	SHOW_HOME_PAGE_CONTENT = 'SHOW_HOME_PAGE_CONTENT',
	NUMBER_OF_MODELS_FOR_COMPARISON = 'NUMBER_OF_MODELS_FOR_COMPARISON',
	REDIRECT_TO_ACT2 = 'REDIRECT_TO_ACT2',
	ACT2_PATHS = 'ACT2_PATHS',
	DETAIL_LINK_KEYS = 'DETAIL_LINK_KEYS'
}

export enum MonitoringConfigKey {
	MONITORING_MENU_ACTIONS = 'MONITORING_MENU_ACTIONS',
	ANALYSIS_GROUPS = 'MONITORING.analysisGroups',
	ENABLE_BENCHMARK_VALUE_TOGGLE = 'ENABLE_BENCHMARK_VALUE_TOGGLE',
	ENABLE_SHOW_HIDE_ALL_BENCHMARK = 'ENABLE_SHOW_HIDE_ALL_BENCHMARK',
	SHOW_ONLY_BLK_MODELS = 'SHOW_ONLY_BLK_MODELS',
	SHOW_PE_BUTTON = 'SHOW_PE_BUTTON',
	SHOULD_CLEANUP_DEFAULT_BENCHMARK = 'SHOULD_CLEANUP_DEFAULT_BENCHMARK',
	ENABLE_LOADING_TIMEOUT_MESSAGE = 'ENABLE_LOADING_TIMEOUT_MESSAGE',
	LOADING_TIMEOUT_MESSAGE_MILLS_VAL = 'LOADING_TIMEOUT_MESSAGE_MILLS_VAL',
	EXCLUDE_PARTNER_PORTFOLIOS_FROM_BENCHMARK = 'EXCLUDE_PARTNER_PORTFOLIOS_FROM_BENCHMARK'
}
